import config from 'garaje/config/environment';

export default function () {
  this.urlPrefix = config.umbrellaHost;

  // **************************************************************************
  // Event reports
  // **************************************************************************
  this.get('/a/hub/v1/event-reports');
  this.get('/a/hub/v1/notification-preferences');
  this.post('/a/hub/v1/notification-preferences');
  this.get('/a/hub/v1/notification-preferences/:id');
  this.patch('/a/hub/v1/notification-preferences/:id');
}
